import styled from 'styled-components';
const SearchConditionStyled = styled.div`
  .search_condition {
    margin-top: 24px;
    height: 106px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    display: flex;
    justify-content: space-between;
    padding: 24px 32px 0 32px;
    .condition_wrap {
    }
    .button-group {
      display: flex;
      gap: 16px;
    }
  }
`;

export default SearchConditionStyled;
